/**
 * The package version, rewritten by `scripts/set-version.cjs` at every
 * release (GENERATED_VERSION_FILES). The literal it replaced, `0.1.0`, never
 * moved from the package's first release, and each browser bundle carried its
 * own `1.0.0-<lang>`. `test/version.test.ts` keeps this equal to package.json.
 */
export const VERSION = '4.8.0';
